/** Winziger Hash-Router als Signal. Views lesen `route`, Navigation via navigate(). */

import { signal } from "@preact/signals";

export type ViewId =
  | "dashboard" | "players" | "player-intel" | "maps" | "chat" | "announcer" | "join-announcer" | "bans"
  | "commands" | "settings" | "console" | "log" | "audit-log" | "users" | "servers" | "ingame-admins"
  | "agent-live" | "files";

function current(): ViewId {
  if (typeof location === "undefined") return "dashboard";
  const h = location.hash.replace(/^#\/?/, "");
  return (h || "dashboard") as ViewId;
}

export const route = signal<ViewId>(current());

if (typeof window !== "undefined") {
  window.addEventListener("hashchange", () => {
    route.value = current();
  });
}

export function navigate(v: ViewId): void {
  if (typeof location !== "undefined") location.hash = `#/${v}`;
}
